export default {"src":"/_next/static/media/abb-vie.79c08cec.svg","height":21,"width":111,"blurWidth":0,"blurHeight":0};